import * as yup from "yup";

export const validation = yup.object().shape({
  email: yup.string().required("Type your email").email("Email is wrong"),
  password: yup.string().required("Type your password"),
});
